import { jsx as _jsx } from "react/jsx-runtime";
import { useDataAttributes } from '@bluebeam/react-hooks';
/** A scrollable container for dialog contents, to be used within a `<Dialog />` component */
const DialogContent = ({ children, ...rest }) => {
    const dataAttributes = useDataAttributes(rest);
    return (_jsx("div", { className: "skyline-text-body-1 flex-auto overflow-auto p-6 leading-[22px] text-black", ...dataAttributes, children: children }));
};
export default DialogContent;
//# sourceMappingURL=DialogContent.js.map